import React from 'react';

import { ApiBalanceHistoryEvent } from '#/api/types';
import { formatUsd } from '#/lib/display/formatting';

export default function BalanceTransactionFee({
  transaction,
}: {
  transaction: ApiBalanceHistoryEvent;
}) {
  if (
    transaction.type === 'transferToWallet' ||
    transaction.type === 'withdrawal'
  ) {
    // Withdrawals and outgoing transfers carry the gas fee paid
    return <>{formatUsd(transaction.gas)} USDC</>;
  }
  return <>-</>;
}
